module.exports = __webpack_public_path__ + "static/media/Skyfarm Drive, Santa Rosa, CA3.aba6188a.jpg";